import script from "./Cropper.vue?vue&type=script&setup=true&lang=js"
export * from "./Cropper.vue?vue&type=script&setup=true&lang=js"

import "./Cropper.vue?vue&type=style&index=0&id=5cdc9ed8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cdc9ed8"]])

export default __exports__